import {useBanner, useUpdateBanner} from "../../services/banner-service";
import {InfoBox} from "../Common/alerts";
import AuthService from "../../services/auth-service";
import {PANON_ADMIN} from "../Permissions/Roles";
import {IconButton} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export const Banner = () => {
    const {data: banner} = useBanner();
    const {isPending, updateBanner} = useUpdateBanner();

    const promptNewBannerText = () => {
        const newText = window.prompt("Enter new banner text:", banner);
        newText && void updateBanner(newText);
    };

    const deleteBanner = () => {
        window.confirm("Are you sure you want to delete the banner text?") && void updateBanner('');
    };

    if (AuthService.hasRole([PANON_ADMIN])) {
        return (
            <InfoBox>
                {banner}
                <IconButton size="small" disabled={isPending} onClick={() => promptNewBannerText()}>
                    <EditIcon/>
                </IconButton>
                <IconButton size="small" disabled={isPending} onClick={() => deleteBanner()}>
                    <DeleteIcon/>
                </IconButton>
            </InfoBox>
        );
    }

    if (!banner) {
        return null;
    }

    return (
        <InfoBox>{banner}</InfoBox>
    );
}